<template>
  <UiItemView :item="item" />
</template>

<script lang="ts" setup>
definePageMeta({
  disableDefaultMargin: true,
  qsearch: true,
})
const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const route = useRoute()
const dataStore = useDataStore()

const item = computed(() => {
  return dataStore.item(route.params.id as string)
})
</script>

<style lang="scss" scoped>
</style>
